import { defineStore, acceptHMRUpdate } from "pinia";

import useGraphql from "@/composables/useGraphql";
import * as lineInfoQueries from "@/graphql/queries/publics/line_info";
import { LineInfoType } from "@/types/publics/LineInfoType";

interface State {
  lineInfo: LineInfoType | null;
  // The button is mounted twice on some pages (side menu + page body), and both
  // instances see lineInfo === null in the same tick. Share the in-flight
  // promise so only one request goes out.
  request: Promise<void> | null;
}

export const useLineInfoStore = defineStore({
  id: "lineInfo",

  state: (): State => ({
    lineInfo: null,
    request: null,
  }),

  actions: {
    async fetchLineInfo() {
      if (this.request) return this.request;

      // errorToasted: false - the toast is raised inside useGraphql, not by the
      // rejection, so a .catch at the call site cannot suppress it. This runs
      // on the LP purchase form; a transient failure must not pop a red toast
      // over it (cartStore.fetchCustomer does the same).
      this.request = useGraphql<LineInfoType>(lineInfoQueries.lineInfo, {}, { errorToasted: false })
        .then((data) => {
          this.lineInfo = data;
        })
        .finally(() => {
          this.request = null;
        });

      return this.request;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLineInfoStore, import.meta.hot));
}
